export default __webpack_public_path__ + "static/media/agEUR.0b08e14c.png";